import React from "react";
import { Navbar } from "../components/Navbar";
import { PageHeader } from "../components/PageHeader";
import { ContactMap } from "../components/ContactMap";
import { Footer } from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";

export default function Contact() {
  const { t, lang } = useLang();
  return (
    <main className="bg-[#F9F8F6] text-[#1A1A1A] font-body" data-testid="page-contact">
      <Navbar transparentOnHome={false} />
      <PageHeader
        eyebrow={t("contact.eyebrow")}
        title={t("contact.title")}
        subtitle={
          lang === "de"
            ? "Anrufen, schreiben oder im Showroom vorbeischauen — wir freuen uns auf Ihr Projekt."
            : "Call us, write or visit the showroom — we look forward to your project."
        }
      />
      <ContactMap hideHeader />
      <Footer />
    </main>
  );
}
